// src/config.js
export const BASE_URL = import.meta.env.VITE_API_URL || 'http://127.0.0.1:8000/api';
//export const BASE_URL = 'http://127.0.0.1:8000/api';



